import { Link } from 'react-router-dom'
import { Container, Grid, Item } from '../common'

import items from '../data/points.json'

const Points = () => {
  return (
    <Container>
      <Grid>
        {Object.keys(items).map((id) => (
          <Link to={id && `/points/${id}`} key={id}>
            <Item item={items[id]} placeholder="/point.svg" />
          </Link>
        ))}
      </Grid>
    </Container>
  )
}

export default Points
